<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-2"></div>
                 <div class="col-md-10">
                    <h5 class="text-left">Modifier !</h5>
                        <form v-on:submit.prevent class="interimaire-form">
                            <div class="form-group row">
                                <label for="salutation" class="col-sm-2 control-label">Salutation</label>
                                <div class="col-sm-5">
                                    <select  class="form-control" v-on:change="sourceSalutationSelect">
                                        <option :value="interimaireById.salutation">{{interimaireById.salutation}}</option>
                                        <option>Monsieur</option>
                                        <option>Madame</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="nom" class="col-sm-2 control-label"> Nom</label>
                                <div class="col-sm-5">
                                    <input autofocus required :value="interimaireById.nom" placeholder="Nom" autocomplete="off" class="form-control"  v-on:keyup.stop="updateField('nom',$event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="prenom" class="col-sm-2 control-label">Prénom</label>
                                <div class="col-sm-5">
                                    <input 
                                        :value="interimaireById.prenom"
                                        class="form-control"
                                        placeholder="Prénom"
                                        autocomplete="off"
                                        type="text" 
                                        v-on:keyup.stop="updateField('prenom',$event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="adresse" class="col-sm-2 control-label">Adresse</label>
                                <div class="col-sm-5">
                                    <input :value ="interimaireById.adresse" name="adresse" type="text" class="form-control" placeholder="Adresse" v-on:keyup.stop="updateField('adresse', $event.target.value)" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="email" class="col-sm-2 control-label"> Email</label>
                                <div class="col-sm-5">
                                    <input  :value="interimaireById.email" name="email" type="text" class="form-control" placeholder="Email" v-on:keyup.stop="updateField('email',$event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numss" class="col-sm-2 control-label"> Num. SS</label>
                                <div class="col-sm-5">
                                    <input 
                                        name="numss"
                                        type="text"
                                        class="form-control"
                                        placeholder="Num. sécurité sociale"
                                        :value="interimaireById.numss"
                                        v-on:keyup.stop="updateField('numss',$event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="telephone" class="col-sm-2 control-label">Telephone</label>
                                <div class="col-sm-5">
                                    <input name="telephone" type="text" class="form-control" placeholder="Num. téléphone" :value ="interimaireById.telephone" v-on:keyup.stop="updateField('telephone',$event.target.value)"/>
                                </div>
                            </div>
                        
                            <div class="form-group row">
                                <label for="nationalite" class="col-sm-2 control-label">Nationalité</label>
                                <div class="col-sm-5">
                                    <select class="form-control" v-on:change="sourceNationaliteSelect">
                                       <option  :value="interimaireById.nationalite">{{interimaireById.nationalite}}</option>
                                       <option  >France</option>
                                       <option  >Italie</option>
                                    </select>
                                </div>
                            </div>
                            <!-- date naissance -->
                            <div class="form-group row">
                                <label class="col-sm-2 control-label"> Date de naissance</label>
                                <div class="col-sm-5">
                                    <input 
                                        name ="date_naiss"
                                        type="date"
                                        class="form-control"
                                        :value="interimaireById.dateNaiss"
                                        v-on:keyup.stop="updateField('dateNaiss' ,$event.target.value)" 
                                        >
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="lieuNaiss" class="col-sm-2 control-label">Lieu de naissance</label>
                                <div class="col-sm-5">
                                    <input name="lieuNaiss" type="text" class="form-control" placeholder="Lieu de naissance" :value="interimaireById.lieuNaiss" v-on:keyup.stop="updateField('lieuNaiss' ,$event.target.value)" />
                                </div>
                            </div>
                              <div class="form-group row">
                                <label for="actif" class="col-sm-2 control-label">Actif ?</label>
                                <div class="col-sm-5">
                                    <select class="form-control" v-on:change="sourceActifSelect">
                                       <option  :value="interimaireById.actif">{{interimaireById.actif ?"Oui":"Non"}}</option>
                                       <option  >{{!interimaireById.actif?"Oui":"Non"}}</option>
                                      
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                            <button class="btn btn-primary" type="submit" @click="updateInterimaire">Valider</button>
                            <button class="btn btn-secondary ml-2" type="submit" @click="cancel">Annuler</button>
                            </div>
                        </form>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../../router'
    import AppNav from '../AppNav'
    import {
        UPDATE_INTERIM,
        INTERIMAIRE_BY_ID 
    } from '../../constants/interim'

  const pageSize = 10

  export default {
    name: 'interim-edit',
    components: {
      AppNav
    },
    data() {
      return {
        interimaireById: {},
        nom:  "",
        prenom: "",
        adresse: "",
        email: "",
        numsss: "",
        telephone:"",
        salutation: "",
        lieuNaiss: "",
        dateNaiss: "",
        actif: null,
      }
    },
    apollo: {
      interimaireById: {
            query: INTERIMAIRE_BY_ID,
            variables() {
                var id = parseInt(this.$route.params.id,10)
                return{
                    id
                }
            }
        }
    },
    methods: {
        cancel () {
            router.push({name: 'Interimaire' , params: { id: this.interimaireById.id}})
        },
        sourceActifSelect(e) {
            //TODO: I probably miss something in the dropbox
            this.actif = (e.target.value === 'Oui' || e.target.value ===  true )?true:false;
        },
        sourceNationaliteSelect(e) {
            this.nationalite = e.target.value
        },
        sourceSalutationSelect(e) {
            this.salutation = e.target.value
        },
        updateField(field,value) {
             this[field] = value
        },
         updateInterimaire() {
            const nom = (this.nom == "") ? this.interimaireById.nom : this.nom
            const prenom = (this.prenom == "") ? this.interimaireById.prenom : this.prenom
            const adresse = (this.adresse == "") ? this.interimaireById.adresse : this.adresse
            const email = (this.email == "") ? this.interimaireById.email : this.email
            const numss = (this.numss == "") ? this.interimaireById.numss : this.numss
            const telephone = (this.telephone == "") ? this.interimaireById.telephone : this.telephone
            const nationalite = (this.nationalite == "") ? this.interimaireById.nationalite : this.nationalite
            const salutation = (this.salutation == "") ? this.interimaireById.salutation : this.salutation
            const lieuNaiss = (this.lieuNaiss == "") ? this.interimaireById.lieuNaiss : this.lieuNaiss
            const dateNaiss = (this.dateNaiss == "") ? this.interimaireById.dateNaiss : this.dateNaiss
            const actif = (_.isNull(this.actif))? this.interimaireById.actif :this.actif
            console.log('interimaire', this.interimaireById)
            this.$apollo.mutate({
                mutation: UPDATE_INTERIM,
                variables: {
                    id: this.interimaireById.id,
                    nom,
                    prenom,
                    adresse,
                    email,
                    numss,
                    telephone,  
                    salutation,   
                    dateNaiss,
                    lieuNaiss,  
                    nationalite,
                    actif        
                }
            }).then((data) => {
                console.log('data', data)
            router.push({name: 'Interimaire' , params: { id: this.interimaireById.id}})
            }).catch((error) => {
            // Error
            console.error(error)
            })
       }
    }
  }

</script>
<style scoped>
/* Move down content because we have a fixed navbar that is 3.5rem tall */

body {
    padding-top: 3.5rem;
}
/*
 * Typography
 */

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}
/*
 * Sidebar
 */

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.interimaire-form{
    padding-bottom: 60px;
    padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// interimEdit.vue?30b96bed